import React from "react";
import { AccountType, getErrorPopupTexts } from "component-library";
import { GetCommonTranslation } from "store/translation/translation.types";
import { HidePopup, SetLoading } from "store/ui/ui.types";
import getErrorPopupType from "helpers/getErrorPopupType";
import ErrorPopup from "components/Popups/ErrorPopup/ErrorPopup";
import { captureExceptionEvent } from "shared-services";

export interface IWithLocalizedDataProps {
  isCommonTranslationLoaded: boolean;
  userType: AccountType;
  locale: string;
  setLoading: SetLoading;
  hidePopup: HidePopup;
  getCommonTranslation: GetCommonTranslation;
}

interface IWithLocalizedDataState {
  showError: boolean;
}

export default function withLocalizedData(
  WrappedComponent: React.ComponentType<
    React.PropsWithChildren<IWithLocalizedDataProps>
  >
): React.ComponentType<React.PropsWithChildren<IWithLocalizedDataProps>> {
  return class extends React.Component<
    IWithLocalizedDataProps,
    IWithLocalizedDataState
  > {
    public readonly state: IWithLocalizedDataState = { showError: false };

    public componentDidMount(): void {
      this.loadData();
    }

    public componentDidUpdate(prevProps: IWithLocalizedDataProps): void {
      if (this.props.locale !== prevProps.locale) {
        this.loadData(true);
      }
    }

    public handleClick = () => {
      location.reload();
    };

    public render(): React.ReactNode | null {
      if (this.state.showError) {
        return this.renderErrorPopup();
      }

      if (!this.props.isCommonTranslationLoaded) {
        return null;
      }

      return <WrappedComponent {...this.props} />;
    }

    public renderErrorPopup() {
      return (
        <ErrorPopup
          {...getErrorPopupTexts()[getErrorPopupType()]}
          handleButtonClick={this.handleClick}
          handleCloseClick={this.handleClick}
          hidePopup={this.props.hidePopup}
        />
      );
    }

    private async loadData(throwOnError: boolean = false) {
      try {
        await this.props.getCommonTranslation(
          { locale: this.props.locale },
          { throwOnError }
        );
      } catch (e) {
        captureExceptionEvent(e);
        this.props.setLoading(false);
        this.setState({
          showError: true,
        });
      }
    }
  };
}
